import { useEffect, useRef } from 'react';
import { DD } from '@tcc/analytics';

const APPLICATION_VIEW_LOAD_VITAL = 'application_view_load';

/**
 * Records a Datadog RUM duration vital measuring how long ApplicationView shows
 * the shared-data loading spinner before the real page renders. Timing starts
 * while `isAppLoading` is true and stops once it flips to false. All RUM calls
 * are gated on an available instance, and the vital is recorded at most once.
 */
export const useApplicationViewLoadVital = (isAppLoading: boolean): void => {
  const hasStartedRef = useRef(false);
  const hasRecordedRef = useRef(false);

  // Start timing when the shared-data loading spinner is shown.
  useEffect(() => {
    if (hasRecordedRef.current || hasStartedRef.current || !isAppLoading) return;
    DD.startDurationVital(APPLICATION_VIEW_LOAD_VITAL, {
      context: { gate: 'shared_data' },
      description: 'Time the shared-data loading spinner is shown before the app renders',
    });
    hasStartedRef.current = true;
  }, [isAppLoading]);

  // Stop timing once shared data resolves and the real page renders.
  useEffect(() => {
    if (hasRecordedRef.current || isAppLoading || !hasStartedRef.current) return;
    DD.stopDurationVital(APPLICATION_VIEW_LOAD_VITAL);
    hasRecordedRef.current = true;
  }, [isAppLoading]);
};
